import { getAxiosInstance } from "../ApiConfig";

async function FetchgetSalesTargetWithGoalsByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getSalesTargetWithGoalsByAccountId/${id}/${account}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchgetAllOepenDealByAccountId(id, account, isQualified) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllOepenDealByAccountId/${id}/${account}/${isQualified}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchgetAllClosedDealByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllClosedDealByAccountId/${id}/${account}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchleadConversionByAccount(account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/leadConversionByAccount/${account}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchcontactByAccountAndId(account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/contactByAccountAndId/${account}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchaccountActivityReportByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/accountActivityReportByAccountId/${id}/${account}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchresourceUtilizationReportByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/resourceUtilizationReportByAccountId/${id}/${account}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllEntityScoreForLastSixmonth(type,id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllEntityScoreForLastSixmonth/${type}/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchgetSalesTargetWithGoalsByAccountId,
    FetchgetAllOepenDealByAccountId,
    FetchgetAllClosedDealByAccountId,
    FetchleadConversionByAccount,
    FetchcontactByAccountAndId,
    FetchaccountActivityReportByAccountId,
    FetchresourceUtilizationReportByAccountId,
    FetchAllEntityScoreForLastSixmonth
}